import { styled } from "../../../styles";

interface HighlightTextAreaContainerProps {
    focused: boolean;
    showContextButton: boolean;
    font?: string;
    minHeight?: number;
    alignTop?: boolean;
}

export const HighlightTextAreaContainer = styled.div<HighlightTextAreaContainerProps>`
    display: flex;
    align-items: ${p => (p.alignTop ? "flex-start" : "center")};
    min-height: ${p => p.minHeight ?? 32}px;
    padding: 7px ${p => (p.showContextButton ? 4 : 8)}px 7px 8px;
    background-color: ${p => p.theme.formControlBg};
    border: 1px solid ${p => (p.focused ? p.theme.dropdownButton.borderOpen : p.theme.dropdownButton.borderNormal)};
    border-radius: ${p => p.theme.formControlRadius};
    font-size: 13px;
    line-height: 16px;
    transition: background-color ${p => p.theme.transitionBase};

    ${p => p.font !== undefined && `font-family: ${p.font};`}

    > :first-child {
        flex-grow: 1;
    }

    > .context-button {
        min-width: 24px;
        padding: 4px 4px;
        align-self: flex-end;
        cursor: pointer;
    }

    &:hover,
    &:focus {
        background-color: ${p => p.theme.formControlBgHover};
    }
`;

export const Error = styled.div`
    font-size: 11px;
    color: ${p => p.theme.destroyColor};
    margin-top: 4px;
`;
